// Baked-in content for the static Netlify build (REACT_APP_STATIC_MODE=true).
// The actual values live in friendly, commented files under src/content/ —
// edit those, then run: yarn export:netlify
//
// getContent() also applies overrides saved in the browser by the static
// /buildweb dashboard (localStorage), so dashboard edits preview instantly
// on the owner's device.

import { jobs } from "@/content/jobs";
import { gallery } from "@/content/gallery";
import { testimonials } from "@/content/testimonials";
import { partners } from "@/content/partners";
import { siteSettings } from "@/content/settings";

const BASE = {
  settings: siteSettings,
  partners,
  roles: jobs,
  testimonials,
  gallery,
};

export const STATIC = BASE;

const LS_KEY = "strovyn-content-overrides";

export function getContent() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return BASE;
    return { ...BASE, ...JSON.parse(raw) };
  } catch {
    return BASE;
  }
}

export function saveContent(content) {
  localStorage.setItem(LS_KEY, JSON.stringify(content));
}

export function resetContent() {
  localStorage.removeItem(LS_KEY);
}

export function hasLocalOverrides() {
  try {
    return !!localStorage.getItem(LS_KEY);
  } catch {
    return false;
  }
}

// On the live Netlify site this reads the shared content saved by the
// /buildweb dashboard's Publish button (via the bundled Netlify Function).
// Returns null when there is no shared content or the site isn't on Netlify.
export async function loadRemoteContent() {
  try {
    const res = await fetch("/.netlify/functions/content");
    if (!res.ok) return null;
    const data = await res.json();
    if (!data || Object.keys(data).length === 0) return null;
    return { ...BASE, ...data };
  } catch {
    return null;
  }
}

export async function publishRemoteContent(content, password) {
  const res = await fetch("/.netlify/functions/content", {
    method: "POST",
    headers: { "Content-Type": "application/json", "x-dash-password": password },
    body: JSON.stringify(content),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Publish failed (${res.status})`);
  }
  return res.json();
}
